import React from 'react'

import { palette, RingLoader } from '@centivo/react-components'
import ReactModal, { Props, Styles } from 'react-modal'
import { useSliceTemplate } from 'src/context/global'

const style: Styles = {
  content: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    width: 'max-content',
    boxShadow: 'none',
    marginTop: '20vh',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
}

export const LoadingOverlay: React.FC<Omit<Props, 'style'>> = props => {
  const isSliceTemplate = useSliceTemplate()

  const color = isSliceTemplate ? palette.brand.orange : palette.brand.pink

  return (
    <ReactModal style={style} {...props}>
      <RingLoader size="4rem" color={color} />
    </ReactModal>
  )
}
